import { wagmiConfig as config, } from "@wagmiconfig";
import { getTokenDefinition, } from "@bracket/chainography";
import { amountToBigInt, } from "../helpers";
import { isNativeToken, } from "./isNativeToken";
import { calculateBurn, } from "@bracket/contractor-next/brktETH";

import type {
	GetQuoterProps,
	GetQuoteResult,
} from "./getQuote";



/**
 * Calculates the burn amount for a given token and amount.
 * 
 * @param {Object} params - Parameters for the calculation
 * @param {string} params.tokenOut - The token to burn
 * @param {string} params.amount - The amount to burn
 * @returns {Promise<GetQuoteResult>} The result of the burn calculation
 * @throws {Error} If the burn calculation fails
 */
export const calculateBurnAmount = async ({
  tokenOut,
  amount,
}: GetQuoterProps): Promise<GetQuoteResult> => {

	const tok = getTokenDefinition(tokenOut);
	const bAmount = amountToBigInt(amount, tok);

	if(isNativeToken(tok)) {
		throw new Error("SwapStore::calculateBurnAmount: Native tokens are not supported");
	}

	if(bAmount === BigInt(0)) {
		return {
			token: tok,
			amount: BigInt(0),
			native: false,
		}
	}

	try {
		const result = await calculateBurn({
			token: tok,
			amount: bAmount,
			config,
		});

		return {
			token: tok,
			amount: result,
			native: false,
		};

	}
	catch(err) {

		throw new Error(`@bracket/platform/client/store/slices/swap/resolvers/calculateBurnAmount: ${err instanceof Error ? err.message : "unknown error"}`);
	}

}